import { render, staticRenderFns } from "./StartupInfo.vue?vue&type=template&id=2fc2ad3c&scoped=true&"
import script from "./StartupInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupInfo.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc2ad3c",
  null
  
)

export default component.exports